const BUILTIN_PHYSICS = 'builtin_physics'

module.exports = {BUILTIN_PHYSICS}
